export const LOCATION_DENIED_KEY = 'meshumLocationDenied';
let locationRequestInFlight = null;

export function isValidZip(value) {
  return /^[0-9]{5}$/.test(String(value || '').trim());
}

export function getStoredZip(storage = window.localStorage) {
  try {
    const lastFilters = JSON.parse(storage.getItem('lastFilters') || '{}');
    if (isValidZip(lastFilters?.zip)) return String(lastFilters.zip).trim();
  } catch {
    // Ignore malformed saved filters and try the last search URL.
  }

  try {
    const lastSearch = storage.getItem('lastSearchURL');
    const storedZip = lastSearch ? new URL(lastSearch, window.location.origin).searchParams.get('zip') : '';
    if (isValidZip(storedZip)) return storedZip.trim();
  } catch {
    // Ignore malformed saved URLs.
  }

  return '';
}

export function persistRecentZip(zip, storage = window.localStorage) {
  if (!isValidZip(zip)) return;

  let lastFilters = {};
  try {
    lastFilters = JSON.parse(storage.getItem('lastFilters') || '{}') || {};
  } catch {
    lastFilters = {};
  }
  storage.setItem('lastFilters', JSON.stringify({ ...lastFilters, zip: String(zip).trim() }));
}

export function wasLocationDenied(storage = window.localStorage) {
  return storage.getItem(LOCATION_DENIED_KEY) === 'true';
}

export function requestLocationZip({
  apiBase = process.env.REACT_APP_API_BASE,
  storage = window.localStorage,
  geolocation = navigator.geolocation,
  fetchImpl = window.fetch.bind(window),
} = {}) {
  if (wasLocationDenied(storage) || !geolocation) return Promise.resolve('');
  if (locationRequestInFlight) return locationRequestInFlight;

  window.gtag?.('event', 'location_request');

  locationRequestInFlight = new Promise((resolve) => {
    geolocation.getCurrentPosition(
      async ({ coords }) => {
        try {
          const query = new URLSearchParams({
            lat: String(coords.latitude),
            lng: String(coords.longitude),
          });
          const response = await fetchImpl(`${apiBase}/location/nearest-zip?${query.toString()}`);
          if (!response.ok) throw new Error('Nearest ZIP lookup failed');
          const data = await response.json();
          if (!isValidZip(data?.zip)) throw new Error('Nearest ZIP response was invalid');

          const zip = String(data.zip).trim();
          persistRecentZip(zip, storage);
          window.gtag?.('event', 'location_success');
          resolve(zip);
        } catch {
          window.gtag?.('event', 'location_lookup_failed');
          resolve('');
        }
      },
      (error) => {
        if (error?.code === 1 || (error?.PERMISSION_DENIED != null && error.code === error.PERMISSION_DENIED)) {
          storage.setItem(LOCATION_DENIED_KEY, 'true');
          window.gtag?.('event', 'location_denied');
        } else {
          window.gtag?.('event', 'location_lookup_failed');
        }
        resolve('');
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    );
  }).finally(() => {
    locationRequestInFlight = null;
  });
  return locationRequestInFlight;
}
